import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-activity',
  templateUrl: './order-activity.component.html',
  styleUrls: ['./order-activity.component.css']
})
export class OrderActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
